import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SidebarMenuItem } from 'src/app/modules/common-features/sidebar/models/sidebar-menu-item.model';
import { ResponsiveService } from 'src/app/shared/services/responsive.service';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { iconColors } from '@app/shared/constants';

@Component({
  selector: 'sidebar-menu-item',
  templateUrl: './sidebar-menu-item.component.html',
  styleUrls: ['./sidebar-menu-item.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SidebarMenuItemComponent implements OnInit {
  @Input()
  public item: SidebarMenuItem;

  @Input()
  public isCollapsed: boolean;

  @Input()
  public count = 0;

  public iconColors = iconColors;
  public isHovered = false;
  public isMobileDevice = false;

  constructor(private readonly responsiveService: ResponsiveService, public readonly layoutService: LayoutService) {}

  public ngOnInit(): void {
    this.isMobileDevice = this.responsiveService.isMobileWidth() && this.responsiveService.isTouchscreen();
  }

  public onClick(): void {
    this.item.action();

    if (!this.item.disableCollapse) {
      this.layoutService.sidebarComponent.closeAllContainers();
    }

    if (this.responsiveService.isMobileWidth()) {
      this.layoutService.closeSidebar();
    }
  }
}
